export default __webpack_public_path__ + "static/media/faq.83cf6316.svg";